import { ActionReducer, MetaReducer } from '@ngrx/store';
import { State } from '~/modules';
import { logoutFailure, logoutSuccess } from '@qvs/core/auth';
import { PersistenceService } from '~/shared/services/persistence.service';
import { merge } from 'lodash-es';

export const resetMetaReducerFactory =
  (persistenceService: PersistenceService): MetaReducer<State> =>
  (reducer: ActionReducer<State>) =>
  (state, action) => {
    if (action.type === logoutSuccess.type || action.type === logoutFailure.type) {
      const reducerAppliedState = reducer(state, action);
      const whiteListState = persistenceService.pickWhiteListObject(reducerAppliedState);
      // setting state to undefined will cause reducers to return their initial states
      const resetState = reducer(undefined, action);
      return merge({}, resetState, whiteListState);
    }
    return reducer(state, action);
  };
